<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" #form="ngForm">
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ "forms.dateRange.labels.range" | translate }}</mat-label>
        <mat-date-range-input (click)="picker.open()" [rangePicker]="picker">
          <input matStartDate formControlName="from" placeholder="{{ 'forms.dateRange.labels.from' | translate }}" />
          <input matEndDate formControlName="to" placeholder="{{ 'forms.dateRange.labels.to' | translate }}" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-error>{{ getError("from") || getError("to") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="withSubmit" class="row justify-content-end mt-2">
    <div class="col-md-auto">
      <button mat-raised-button [appButtonLoading]="formLoading.loading" color="primary">
        {{ submitText | translate }}
      </button>
    </div>
  </div>
</form>
